import { VFlex } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VFlex,[_c('bar-chart',{attrs:{"chart-data":_vm.favoriteDrillStats,"options":_vm.options,"styles":_vm.barChartStyles,"title":"Groups"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }